/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { Toaster } from 'app/shared/lib/toaster';
import { apiCall } from 'app/shared/lib/essette-api';
import { ProviderService } from 'app/cd/services/provider-service';
import { getReference } from 'app/shared/models/essette-types';
import * as CD from 'app/cd/models/essette-api';

@autoinject()
export class SaveProviderContract extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable.object
    protected contract: CD.ProviderContract = {};

    @bindable
    protected providerGroup: CD.ProviderGroup = {};

    @bindable.array()
    protected contractHealthPlans: ReadonlyArray<CD.HealthPlan> | null = null;

    @bindable.array()
    protected contractLinesOfBusiness: ReadonlyArray<CD.LineOfBusiness> | null = null;

    protected startDate: string | null = null;
    protected endDate: string | null = null;

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: ProviderService,
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////

    public reset(): void {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        return this.saveProviderContract();
    }

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    private buildProviderContract(): CD.ProviderContract {
        const saveProviderContract: CD.ProviderContract = {
            ...this.contract,
            healthPlan: getReference(this.contract.healthPlan),
            lineOfBusiness: getReference(this.contract.lineOfBusiness),
            group: getReference(this.providerGroup)
        };
        return saveProviderContract;
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async saveProviderContract(): Promise<boolean> {
        let isSuccessful = false;
        try {
            this.state.beginSave();

            const response = await this.service.saveProviderContract(this.buildProviderContract());
            isSuccessful = response.isSuccessful;
        } catch(error) {
            throw error;
        } finally {
            this.toaster.standard.saved('cd:providerContract.$', isSuccessful);
            this.state.endSave();
            return isSuccessful;
        }
    }
}
